/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FederatedSearchOutput,
  ListFederatedSearchesParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Federated Search
 */
export const listFederatedSearches = (
    params?: MaybeRefOrGetter<ListFederatedSearchesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FederatedSearchOutput>(
      {url: `/federated_searches`, method: 'GET',
        params, signal
    },
      );
    }




export const getListFederatedSearchesQueryKey = (params?: MaybeRefOrGetter<ListFederatedSearchesParams>,) => {
    return [
    'federated_searches', ...(params ? [params] : [])
    ] as const;
    }


export const getListFederatedSearchesQueryOptions = <TData = Awaited<ReturnType<typeof listFederatedSearches>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListFederatedSearchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFederatedSearches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFederatedSearchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFederatedSearches>>> = ({ signal }) => listFederatedSearches(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFederatedSearches>>, TError, TData>
}

export type ListFederatedSearchesQueryResult = NonNullable<Awaited<ReturnType<typeof listFederatedSearches>>>
export type ListFederatedSearchesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Federated Search
 */

export function useListFederatedSearches<TData = Awaited<ReturnType<typeof listFederatedSearches>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListFederatedSearchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFederatedSearches>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFederatedSearchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






